import React, { useState } from 'react';
import { useI18n, LanguageSwitcher } from '../i18n';

export default function Header({ onTeacherClick }) {
  const { t } = useI18n();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleTeacherClick = () => {
    setIsMenuOpen(false);
    if (onTeacherClick) onTeacherClick();
  };
  
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const navItems = [
    { id: 'vision', label: t('nav.vision') },
    { id: 'how-it-works', label: t('nav.howItWorks') },
    { id: 'about', label: t('nav.about') },
    { id: 'contact', label: t('nav.contact') },
  ];

  return (
    <header className="flex justify-between items-center px-4 py-5 md:px-8 lg:px-12 fixed w-full top-0 left-0 bg-white/90 backdrop-blur-md border-b border-black/5 z-50 transition-all">
      <button 
        onClick={() => scrollToSection('home')} 
        className="text-2xl tracking-widest font-bold text-black hover:opacity-80 transition-opacity"
      >
        FAUS
      </button>
      
      {/* Desktop Navigation */}
      <nav className="hidden md:flex gap-4 text-sm font-medium md:gap-7 items-center text-black/70">
        {navItems.map((item) => (
          <button 
            key={item.id}
            onClick={() => scrollToSection(item.id)} 
            className="hover:text-black transition-colors py-1"
          >
            {item.label}
          </button>
        ))}
        <LanguageSwitcher className="ml-1 text-black/80" />
        <a
          href="/app/"
          className="bg-black text-white text-xs font-bold tracking-widest px-5 py-2.5 rounded-full hover:bg-neutral-800 transition-all hover:-translate-y-0.5 shadow-sm uppercase"
        >
          {t('common.imStudent')}
        </a>
        <button
          onClick={handleTeacherClick}
          className="bg-white text-black border-2 border-black text-xs font-bold tracking-widest px-5 py-2.5 rounded-full hover:bg-neutral-100 transition-all hover:-translate-y-0.5 uppercase"
        >
          {t('common.imTeacher')}
        </button>
      </nav>

      {/* Mobile Menu Button */}
      <button 
        className="md:hidden p-2 text-black hover:opacity-70 rounded-lg"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label="Toggle menu"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          {isMenuOpen ? (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          ) : (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          )}
        </svg>
      </button>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="absolute top-full left-0 w-full bg-white/98 backdrop-blur-md md:hidden border-b border-black/10 shadow-xl">
          <nav className="flex flex-col py-4">
            {navItems.map((item) => (
              <button 
                key={item.id}
                onClick={() => scrollToSection(item.id)} 
                className="py-3 px-8 text-left text-black/80 hover:bg-neutral-100 hover:text-black transition-colors font-medium text-sm"
              >
                {item.label}
              </button>
            ))}
            <div className="flex flex-col gap-2.5 px-8 pt-3 pb-4">
              <a
                href="/app/"
                className="bg-black text-white text-xs font-bold tracking-widest px-5 py-3 rounded-full text-center hover:bg-neutral-800 transition-all uppercase"
              >
                {t('common.imStudent')}
              </a>
              <button
                onClick={handleTeacherClick}
                className="bg-white text-black border-2 border-black text-xs font-bold tracking-widest px-5 py-3 rounded-full hover:bg-neutral-100 transition-all text-center uppercase"
              >
                {t('common.imTeacher')}
              </button>
            </div>
            <div className="px-8 py-3 border-t border-black/5">
              <LanguageSwitcher />
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
